import { render, staticRenderFns } from "./InvoiceReviewsForm.vue?vue&type=template&id=ad296ef6&"
import script from "./InvoiceReviewsForm.vue?vue&type=script&lang=js&"
export * from "./InvoiceReviewsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports